module.exports = __webpack_public_path__ + "static/media/icoLoading-2.ec710d1f.svg";